import React from 'react'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Tooltip } from '@mui/material'

import { capitalize } from '@albacross/frontend-utils'

import { DescriptionListTable } from 'components/table'
import { formatDate } from 'utils/date'

type InfoTooltipProps = {
  text: string
}

const InfoTooltip = ({ text }: InfoTooltipProps) => (
  <Tooltip title={text}>
    <span aria-label={text} role="img" style={{ display: 'inline-flex' }} tabIndex={0}>
      <InfoOutlinedIcon style={{ fontSize: 14, marginLeft: 4, verticalAlign: 'middle', opacity: 0.5 }} />
    </span>
  </Tooltip>
)

const config = [
  {
    title: 'First name',
    field: 'first_name',
  },
  {
    title: 'Last name',
    field: 'last_name',
  },
  {
    title: 'E-mail',
    field: 'email',
  },
  {
    title: 'Admin',
    render: ({ admin }: any) => capitalize(admin.toString()),
  },
  {
    title: (
      <span>
        Last Logged In <InfoTooltip text="When the user last signed in and got a new session token." />
      </span>
    ),
    render: ({ last_login }: any) => (last_login ? formatDate(last_login) : '–'),
  },
  {
    title: (
      <span>
        Last Active{' '}
        <InfoTooltip text="When the user last used the app. Updated at most once per hour while they have an active session." />
      </span>
    ),
    render: ({ last_active_at }: any) => (last_active_at ? formatDate(last_active_at) : '–'),
  },
  {
    title: 'Created',
    render: ({ created_at }: any) => formatDate(created_at),
  },
  {
    title: 'Updated',
    render: ({ updated_at }: any) => formatDate(updated_at),
  },
  {
    title: 'Deleted',
    render: ({ deleted_at }: any) => (deleted_at ? formatDate(deleted_at) : '–'),
  },
]

type UserDetailsProps = {
  data: any
}

const UserDetails = ({ data }: UserDetailsProps) => <DescriptionListTable config={config} data={data} />

export default UserDetails
